module.exports = __webpack_public_path__ + "img/eye_icon.80b130c5.svg";